import { defineComponent } from 'vue';

import { Nullable } from '@/utils/types';
import { formatNumber } from '@/utils/filters';

const CursorManagementMixin = defineComponent({
  data: (): {
    cursorPosition: Nullable<number>;
    inputValueAtCursor: string;
  } => ({
    cursorPosition: null,
    inputValueAtCursor: '',
  }),

  methods: {
    saveCursorPosition (refName = 'numberInputRef') {
      const inputRef = (this.$refs[refName] as any);
      const input = inputRef?.$el?.querySelector('input');

      if (input) {
        this.cursorPosition = input.selectionStart;
        this.inputValueAtCursor = input.value || '';
      }
    },
    restoreCursorPosition (inputValue: string, newValue: string, refName = 'numberInputRef') {
      const inputRef = (this.$refs[refName] as any);
      const input = inputRef?.$el?.querySelector('input');

      if (!input || this.cursorPosition === null) return;

      const beforeCursor = inputValue.slice(0, this.cursorPosition);
      const digitsBeforeCursor = beforeCursor.replace(/[^\d.]/g, '').length;

      let newPosition = 0;
      let digitCount = 0;

      for (let i = 0; i < newValue.length; i++) {
        const isDigit = /[\d.]/.test(newValue[i]);
        if (isDigit) {
          digitCount++;
        }

        if (digitCount === digitsBeforeCursor) {
          newPosition = i + 1;
          break;
        }
      }

      if (digitCount < digitsBeforeCursor) {
        newPosition = newValue.length;
      }

      input.setSelectionRange(newPosition, newPosition);
      this.cursorPosition = null;
      this.inputValueAtCursor = '';
    },
    formatNumberPreservingDecimals (stringValue: string): string {
      const [intPart = '0', decPart] = stringValue.split('.');
      return decPart !== undefined ? `${formatNumber(intPart)}.${decPart}` : formatNumber(intPart);
    },
    updateInputProgrammatically (value: any, refName = 'numberInputRef') {
      const inputRef = (this.$refs[refName] as any);

      if (inputRef) {
        inputRef.lazyValue = value;
      }
    }
  }
});

export { CursorManagementMixin };
